import { createSelector } from "reselect";
import _ from "lodash";
const createSelectors = (parentReducer) => {
    return new (class {
        selectAllUsers = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["JobPackTrainingRulesWidget_reducer"];
            return reducer.users;
        };
        selectAllToolboxes = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["JobPackTrainingRulesWidget_reducer"];
            return reducer.toolboxes;
        };
        selectAllQualifications = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["JobPackTrainingRulesWidget_reducer"];
            return reducer.allQualifications;
        };
        selectQualifications = createSelector(
            [this.selectAllQualifications],
            (qualifications = false) => {
                if (qualifications) {
                    let totalRequiredQualifications = getRequiredQualifications(
                        qualifications
                    );

                    return totalRequiredQualifications;
                } else return false;
            }
        );
        selectUserInfo = createSelector(
            [this.selectAllUsers],
            (users = false) => {
                if (users) {
                    let userInfo = _.compact(
                        Object.keys(users).map((e) => {
                            let uid = e;
                            let fname =
                                _.get(users[e], "profile.first_name") || "N/A";
                            let lname =
                                _.get(users[e], "profile.last_name") || "N/A";
                            let qualifications =
                                _.get(
                                    users[e],
                                    "profile.qualifications_per_user"
                                ) || [];
                            let deleted =
                                _.get(users[e], "profile.deleted") || false;
                            if (!deleted) {
                                return {
                                    uid,
                                    user_name: `${fname} ${lname}`,
                                    qualifications,
                                };
                            } else return null;
                        })
                    );
                    return userInfo.sort((a, b) =>
                        a.user_name.localeCompare(b.user_name)
                    );
                } else return false;
            }
        );
        selectToolboxTalks = createSelector(
            [this.selectAllToolboxes],
            (toolboxes = false) => {
                if (toolboxes) {
                    let toolboxInfo = _.compact(
                        Object.keys(toolboxes).map((e) => {
                            let uid = e;
                            let toolbox_topic =
                                _.get(toolboxes[e], "profile.toolbox_topic") ||
                                "N/A";
                            let reports =
                                _.get(toolboxes[e], "reports") || false;
                            let attendees = [];
                            if (reports) {
                                Object.keys(reports).map((ts) => {
                                    let attendee_list =
                                        _.get(toolboxes[e], "attendance") || [];
                                    attendee_list.map((attendant) => {
                                        attendees.push(attendant.uid);
                                        return null;
                                    });
                                    return null;
                                });
                            }

                            return { uid, attendees, toolbox_topic };
                        })
                    );
                    return toolboxInfo.sort((a, b) =>
                        a.toolbox_topic.localeCompare(b.toolbox_topic)
                    );
                } else return false;
            }
        );
    })();
};
const getRequiredQualifications = (qualifications) => {
    let QID = Object.keys(qualifications).filter((qualification_id) => {
        return qualifications[qualification_id].qualification_selected === true;
    });
    return QID.map((e) => {
        return qualifications[e];
    });
};
export default createSelectors;
